import axiosInstance from 'services/axiosMiddleware';

// Function to create a feature notification
export async function createFeatureNotification(data) {
  try {
    const response = await axiosInstance.post('/feature-notifications/create-feature-notifications', data);
    return response.data;
  } catch (error) {
    console.error('Error creating feature notification:', error);
    throw error;
  }
}
